'use es6';

import { DESC } from '../enums/SortDirection';
export default function getFormattedOrderByUsingSortDirection(orderBy, sortDirection) {
  if (sortDirection === DESC) {
    return `-${orderBy}`;
  }
  return orderBy;
}